/* FOODHUB - rewire header heart to custom wishlist page + connect badge to FoodHub.Wishlist */
(function(){
  function rewire(){
    var heart=document.querySelector('.swym-wishlist.h-wishlist-icon, .h-wishlist-icon, header a[href$="#swym-wishlist"]');
    if(heart){
      heart.href='/pages/wishlist';
      heart.setAttribute('aria-label','Mes favoris');
      heart.title='Mes favoris';
    }
    var badge=document.querySelector('.swym-wishlist-header-counter, .thb-item-count');
    if(badge && !badge.hasAttribute('data-wishlist-badge')){
      badge.setAttribute('data-wishlist-badge','');
    }
    if(window.FoodHub && window.FoodHub.Wishlist){
      var c=window.FoodHub.Wishlist.getCount?window.FoodHub.Wishlist.getCount():0;
      if(badge){
        badge.textContent=c>0?String(c):'';
        badge.style.display=c>0?'':'none';
      }
    }
  }
  function go(){
    rewire();
    setTimeout(rewire,300);
    setTimeout(rewire,1000);
    setTimeout(rewire,2500);
  }
  if(document.readyState!=='loading') go();
  else document.addEventListener('DOMContentLoaded',go);
  // Réagir aux events FoodHub
  document.addEventListener('foodhub:wishlist:changed',rewire);
  document.addEventListener('wishlist:updated',rewire);
})();
